/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2018 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */

/**
 * Encapsulates errors on the network, server and request layer that are not of defined shape for logging
 */
export class ApiError extends Error {
  /**
   * Only for logging in Sentry
   */
  public readonly originalError: any;

  /**
   * Creates a new Instance
   * @param {string} message
   * @param originalError
   */
  constructor(message: string, originalError: any) {
    super(`[ApiError] ${message}: ${originalError.message}`);
    this.originalError = originalError;
    this.stack = originalError.stack;
  }
}
